<template>
  <div class="fuwu_page">
    <!-- 返回按钮 + 标题 -->
    <div class="nav_bar">
      <div class="back_btn" @click="goBack">‹</div>
      <div class="nav_title">用户服务协议</div>
    </div>

    <div class="content">
      <h1>用户服务协议</h1>
      <h2>江苏座享智能科技有限公司</h2>
      <h2>用户服务协议</h2>

      <p class="indent">欢迎您使用江苏座享智能科技有限公司提供的智能儿童输液椅相关服务。本协议是您与江苏座享智能科技有限公司之间关于您注册及使用输液椅点播服务所订立的协议。在使用本服务前，请您仔细阅读以下具体条款。您的注册行为将被视为您对本协议的接受。</p>

      <h3>一、协议的范围及内容</h3>
      <p class="indent">本协议是您（以下简称"用户"）与江苏座享智能科技有限公司（以下简称"公司"）之间关于使用本平台所订立的协议。本服务主要包括智能儿童输液椅上的平板设备点播功能及相关配套服务。</p>

      <h3>二、用户注册与使用</h3>
      <p>1. 您在使用本服务前，需通过小程序完成注册流程，并同意本协议的全部内容。</p>
      <p>2. 您应保证注册时提供的信息真实、准确、完整。如因您提供的信息不实导致的后果，公司不承担任何责任。</p>
      <p>3. 未成年人使用本服务需在法定监护人的陪同下进行。</p>

      <h3>三、服务内容</h3>
      <p>1. 本平台向您提供智能输液椅上的平板设备为您提供点播服务，包括但不限于儿童故事、益智游戏、学习资料等。</p>
      <p>2. 本公司有权根据实际情况调整服务内容，无需另行通知。</p>

      <h3>四、服务变更、中断或终止</h3>
      <p>1. 如公司的服务因网络状况、设备维护等原因中途停止的，公司会提前通知。</p>
      <p>2. 如服务内容涉及违反相关法律法规，本公司有权随时终止服务。</p>

      <h3>五、用户个人隐私信息保护</h3>
      <p>1. 本平台严格保护您的个人信息，仅在必要时收集、使用和披露。</p>
      <p>2. 公司将采取合理措施保障您的信息安全，但因不可抗力或第三方手段导致的信息泄露，本公司不承担责任。</p>

      <h3>六、内容规范</h3>
      <p>1. 您在使用本服务时，必须遵守中华人民共和国相关法律法规。</p>
      <p>2. 您不得利用本服务制作、传播、存储发布任何违反法律法规的内容。</p>

      <h3>七、使用规则及禁止</h3>
      <p>1. 您在使用本服务时，应自行承担因使用内容产生的全部责任。</p>
      <p>2. 您不得利用本服务从事任何违法违规活动。</p>
      <p>3. 您在使用过程中如遇到任何问题或疑问均可联系客服热线 400-8280-681。</p>

      <h3>八、免责声明</h3>
      <p>1. 对于因网络故障、设备问题或原因导致的服务中断或受阻，本公司不承担责任。</p>
      <p>2. 本公司不对用户使用本服务产生的任何间接损失不承担责任。</p>

      <h3>九、知识产权声明</h3>
      <p class="indent">本平台中所提供的所有作品、软件内容等均受知识产权法保护，未经本公司书面许可，您不得以任何形式复制、传播或使用。</p>

      <h3>十、法律适用</h3>
      <p>1. 本协议的订立、执行和解释均适用中国法律。</p>
      <p>2. 如双方就本协议内容或其执行发生争议，应友好协商解决；协商不成的，任何一方均可向本公司所在地人民法院提起诉讼。</p>

      <h3>十一、其他</h3>
      <p class="indent">本协议的最终解释权归本公司所有。</p>
    </div>

    <AdultNewTabBar />
  </div>
</template>

<script>
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageFuwu',
  components: { AdultNewTabBar },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.fuwu_page {
  width: 100vw;
  min-height: 100vh;
  background: #f5f8fc;
  box-sizing: border-box;
  padding-bottom: 70px;
}

/* 顶部导航 */
.nav_bar {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.back_btn {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #2c6ba5;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
}
.nav_title {
  font-size: 16px;
  font-weight: 600;
  color: #1a3c5e;
}

/* 内容区 */
.content {
  margin: 12px 14px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  color: #333;
  font-size: 14px;
  line-height: 1.9;
}
.content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #1a3c5e;
  text-align: center;
  margin: 0 0 12px;
}
.content h2 {
  font-size: 15px;
  font-weight: 700;
  color: #1a3c5e;
  text-align: center;
  margin: 0;
}
.content h3 {
  font-size: 14px;
  font-weight: 700;
  color: #1a3c5e;
  margin: 20px 0 8px;
}
.content p {
  margin: 0 0 10px;
  text-align: justify;
}
.content p.indent {
  text-indent: 2em;
}
</style>
